module.exports = __webpack_public_path__ + "components/flag/static/square/am-f6bd07881cc0e4a038782e82b87ee922.svg";